// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/KPMG-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/KPMG-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/KPMG-Extralight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/KPMG-Thin.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'KPMG';
	src: url( ${___CSS_LOADER_URL_REPLACEMENT_0___} );
	font-style: normal;
	font-weight: 400;
}

@font-face {
	font-family: 'KPMG';
	src: url( ${___CSS_LOADER_URL_REPLACEMENT_1___} );
	font-style: normal;
	font-weight: 700;
	font-weight: bold;
}

@font-face {
	font-family: 'KPMG';
	src: url( ${___CSS_LOADER_URL_REPLACEMENT_2___} );
	font-style: normal;
	font-weight: 200;
}

@font-face {
	font-family: 'KPMG';
	src: url( ${___CSS_LOADER_URL_REPLACEMENT_3___} );
	font-style: normal;
	font-weight: 100;
}

body {
	font-family: 'Open Sans', sans-serif;
	font-size: 12pt;
	margin: 0;
	padding: 0;
	color: #02277A;

	background: #fff url( 'https://stssehub749064224099.blob.core.windows.net/aicoach-assets/layout/bg-trades.png' ) bottom center no-repeat;
	background-size: cover;

	/* Prevent long-click */
	-webkit-touch-callout: none !important;
}

body.welcome,
body.instructions { background-image: url('https://stmatchmaker048851067649.blob.core.windows.net/matchmakerassets/layout/bg-form-instructions.png'); }
body.interview { background-image: url('https://stssehub749064224099.blob.core.windows.net/aicoach-assets/layout/bg-conversation-trades.png'); }

a {
	color: #8cdce8;
}

html, body, #page {
	height: 100%;
	box-sizing: border-box;
}

/*
header, footer, div {
	border: solid red 1px;
}

header:after, footer:after, div:after {
	content: 'x';
	position: absolute;
	left: 0;
	top: 0;
	background-color: #33333333;

}
*/

#page {
	display: flex;
	flex-direction: column;
	padding: 5vh 7vw;

	/* Used by speaker viz */
	position: relative;
	overflow: hidden;
}

#content {
	display: flex;
	flex-direction: column;
}

/*
header {
	position: absolute;
	top: 5vh;
	left: 0;
	right: 0;
	margin: 0 5%;
}

footer {
	z-index: -10;
	position: absolute;
	bottom: 5vh;
	left: 0;
	right: 0;
	margin: 0 5%;
}
*/

footer {

}

.logo {
	width: 10vw;
	height: auto;
}

#synapse-logo {
	text-align: right;
}

#synapse-logo img {
	max-width: 15vw;
}

/*
#kpmg-logo {
	position: absolute;
	left: 0;
}

#synapse-logo {
	position: absolute;
	right: 0;
	bottom: 0;
}

*/
@media screen and ( max-width:767px ) {
	#kpmg-logo {
		right: 0;
		text-align: center;
		max-width: 100%;
	}

	.logo { width: 50vw; }

	#synapse-logo {
		left: 0;
		text-align: center;
	}

	#synapse-logo img {
		max-width: 100%;
	}

	#audio_anim_container {
		margin-top: 10vh;
	}
	
	#agent_output {
		padding-top: 3vh;
		padding-bottom: 3vh;
	}

	body #content {
		width: 100%;
		padding: 0;
	}
}

#content {
	width: 65%;
	height: 80vh;

	margin: 0 auto;
	padding: 0 15px;
	font-size: 1.5vw;

	overflow-y: auto;
	overflow-x: hidden;
}

#content.reg-form {
	font-size: 1.2vw;
}

body.results #content {
	font-size: 1.1vw;
	top: 10%;
	left: 10%;
	right: 10%;
	height: auto;
	padding-bottom: 10vh;
	overflow: hidden;
}

.aligncenter {
	text-align: center;
}

h1 {
	font-family: KPMG, sans-serif;
	text-align: center;
	margin-top: 0;
	font-size: 4.5vw; /*64pt;*/
}

.button,
button {
	margin: 10px 5px;
	padding: .5em 1em;
	font-size: inherit;
	background-color: #02277A;
	color: #fff;
	border: inset #ccc 1px;
	border-radius: 10px;
}

.button:active,
button:active {
	position: relative;
	top: 2px;
	left: 2px;
}

#volume_meter {
	width: 100px;
	height: 10px;
	border: solid 1px black;
}

#login-form {
	background-color: #fff;
	color: #000;
	max-width: 300px;
	margin: auto;
	padding: 2em;
	border-radius: .5em;
}

#login-form .message {
	border: solid 1px #ccc;
	background-color: #eee;
	padding: 5px;
	margin-bottom: 1em;
}

.reg-form .message {
	border: solid 1px #ccc;
	background-color: #eee;
	padding: 5px;
	margin-bottom: 1em;
}


.choice-panels,
#topics {
	column-gap: 1em;
	margin-top: 30px;
}

.choice,
.topic {
	display: block;
	border: solid #02277A 1px;
	border-radius: 15px;
	margin-bottom: 1em;
}

.choice:hover,
.topic:hover {
	background-color: #2f51a0;
	color: #fff;
	cursor: pointer;
}

.choice h2,
.topic h2 {
	margin-top: 0;
	margin-bottom: 0;
	line-height: 1.3;
}

a.choice {
	color: #2f51a0;
	text-decoration: none;
}

#audio_anim_container {
	z-index: 10;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

#audio_anim {
	height: auto;
	max-width: 100%;
	max-height: 30vh;
	object-fit: fill;
	opacity: 1;
	scale: 1;
	transition: scale .1s, opacity .1s;
	clip-path: inset(1px 1px); /* Fixed black lines around video when scaling */
}

#thinking_indicator {
	position: relative;
	opacity: 0;
	top: -10px;
	color: #2faff3;
	transition: opacity .1s;
	font-size: .8em;
	animation: none;
}

#thinking_indicator:after {
	content: '...';
	position: absolute;
}

@keyframes thinking {
	0% { opacity: 1; }
	100% { opacity: .5; }
}

@keyframes thinking_phrase {
	0% { opacity: 0 }
	100% { opacity: 1; }
}

.thinking #audio_anim {
	animation-name: thinking;
	animation-duration: 1s;
	animation-direction: alternate;
	animation-iteration-count: infinite;
}

.thinking #thinking_indicator {
	animation-name: thinking_phrase;
	animation-duration: 2.5s;
	animation-direction: alternate;
	animation-iteration-count: infinite;
}


#speaker_visualizer {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	border-radius: 100%;
	width: 60vw;
	height: 20vw;
	margin: auto;

	box-shadow: 0 0 0 #355fe7;
}

#agent_output {
/*
	position: relative;
	z-index: 20;
	margin-top: 0;

	height: 41vh;
*/
	overflow-y: auto;
	overflow-x: hidden;

	font-size: 28px;
	white-space: pre-line;
}

.narrow-width {
	max-width: 800px;
}

.form-field {
	margin-bottom: 1em;
}

.form-field label {
	display: inline-block;
	min-width: 40%;
}

.form-field input {
	font-size: inherit;
}

.form-field input[type=text] {
	width: 50%;
    border: solid #ccc 2px;
    padding: .5em;
    font-size: 18px;
}


.form-field label:after {
    content: ' *';
    color: red;
}


.form-submit input[type=submit] {
	color: #fff;
	background: #02277A;
	border: none;
	border-radius: 5px;

	font-size: inherit;
	cursor: pointer;
}


.selector,
#event_selector {
	padding: .5em 1em;
	font-size: inherit;
	background: #fff;
	border: solid #02277A 2px;
	border-radius: 15px;
}

.selector,
#selector_button {
	font-size: .75em;
}

body.intro h1 {
	position: relative;
	font-weight: bold;
	font-size: 11vw; /*175pt;*/
	margin: 0;
	margin-top: 5%;
	line-height: 1.1;

}

body.intro .heading-prefix {
	font-weight: 300;
	font-family: 'Open Sans', sans-serif;
	color: #8a8a8a;
	position: absolute;
	left: 23%;
	top: 0;
	font-size: 2.5vw;
	letter-spacing: -.15vw;
}

body.intro .heading-smart {
	color: #2faff3;
}

body.intro .event_name {
	font-weight: 300;
	color: #4d4d4d;
	margin: 0;
}

body.intro #content {
	font-size: 1.9vw;
	line-height: 1.1;
}

.press-to-continue,
body.intro .instructions {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	font-size: 1.4vw; /* 20pt;*/
	text-align: center;
}

body.welcome .press-to-continue,
body.instructions .press-to-continue {
	bottom: 10vh;
}

.sme-mockup {

	max-width: 100%;
	max-height: 33vh;
	width: auto;
	height: auto;

}

.expert {
	width: 20%;
	border: solid #02277A 1px;
	font-size: .8em;
	background-color: #fff;
	text-align: left;

}

.expert .expert-photo {
	display: block;
	width: 100%;
	height: auto;
	background-color: #ccc;
	border-bottom: solid black 5px;
}

.expert-name {
	color: #02277A;
	margin: 0;
}

.expert-details {
	color: #888;
	padding: .5em 1em;
}

body.welcome #page,
body.instructions #page {
	padding-top: 15vh;
}

body.welcome #content h1,
body.instructions #content h1 {
	text-align: left;
	margin: 0;
	margin-bottom: .18em;
}

#instruction-content {
	position: relative;
	color: #666666;
	padding-left: 70px;
}

#instruction-content:before {
	position: absolute;
	top: 0;
	left: 0;
	display: inline-block;
	vertical-align: top;
	content: '';
	width: 50px;
	min-height: 100px;
	background-image: url('https://stmatchmaker048851067649.blob.core.windows.net/matchmakerassets/layout/icon-mic.png');
	background-repeat: no-repeat;
	background-size: contain;
}


body.registration #heading {
	position: absolute;
	text-align: left;
	top: 20vh;
	left: 15%;
	width: 20%;
}

body.registration #heading h1 {
	text-align: left;
	line-height: 1;
	margin: 0;
}

body.registration #content {
	position: absolute;
	left: 35%;
	top: 15vh;
	padding: 30px;
	border: solid 1px #ccc;
	box-sizing: border-box;
	height: auto;
}


@keyframes expert-reveal {
	0% {
		transform: translateY(100vh);
		opacity: 0;
	}

	50% {
		opacity: 0;
	}

	100% {
		transform: translateY(0vh);
		opacity: 1;
	}
}

body.results #sme-results .expert  {
	transform: translateY(100vh);
	opacity: 0;
	animation-name: expert-reveal;
	animation-duration: 2s;
	animation-fill-mode: forwards;
}

body.results #sme-results .expert:nth-child(1) { animation-delay: 1s; }
body.results #sme-results .expert:nth-child(2) { animation-delay: 2s; }
body.results #sme-results .expert:nth-child(3) { animation-delay: 3s; }

body.end #content {
	margin-top: 4vw;
	font-size: 1.7vw;
}

#end-qr-code {
	float: right;
	width: 15vw;
}

#talk_trigger {
	z-index: 30;
	position: absolute;
	inset: 0;
}

.listening #talk_trigger {
	background-color: rgba(5, 24, 170, 0.3);
}

#talk_notice {
	border-radius: 50%;
	border: solid 4px #00348d;
	height: calc(min(80vw,80vh));
	width: calc(min(80vw,80vh));
	background-color: #ffffffbb;
	color: #00348d;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-weight: bold;
	font-size: 1.5em;
}

#talk_notice:focus-visible {
	outline: none !important;
}
`, "",{"version":3,"sources":["webpack://./browser/css/styles.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,8CAAqC;CACrC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,8CAAoC;CACpC,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,8CAA0C;CAC1C,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,8CAAoC;CACpC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,eAAe;CACf,SAAS;CACT,UAAU;CACV,cAAc;;CAEd,wIAAwI;CACxI,sBAAsB;;CAEtB,uBAAuB;CACvB,sCAAsC;AACvC;;AAEA;oBACoB,gIAAgI,EAAE;AACtJ,iBAAiB,4HAA4H,EAAE;;AAE/I;CACC,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,sBAAsB;AACvB;;AAEA;;;;;;;;;;;;;CAaC;;AAED;CACC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;;CAEhB,wBAAwB;CACxB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;;;;;;;;;;;;;;;;;CAiBC;;AAED;;AAEA;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;;;;;;;;;;;;CAYC;AACD;CACC;EACC,QAAQ;EACR,kBAAkB;EAClB,eAAe;CAChB;;CAEA,QAAQ,WAAW,EAAE;;CAErB;EACC,OAAO;EACP,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,UAAU;CACX;AACD;;AAEA;CACC,UAAU;CACV,YAAY;;CAEZ,cAAc;CACd,eAAe;CACf,gBAAgB;;CAEhB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,YAAY;CACZ,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,kBAAkB;CAClB,aAAa;CACb,gBAAgB,EAAE,QAAQ;AAC3B;;AAEA;;CAEC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,WAAW;CACX,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;;CAEC,kBAAkB;CAClB,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,gBAAgB;CAChB,YAAY;CACZ,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,YAAY;CACZ,kBAAkB;AACnB;;;AAGA;;CAEC,eAAe;CACf,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;CACd,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;CACzB,WAAW;CACX,eAAe;AAChB;;AAEA;;CAEC,aAAa;CACb,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;CACV,QAAQ;CACR,kCAAkC;CAClC,yBAAyB,EAAE,gDAAgD;AAC5E;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,cAAc;CACd,uBAAuB;CACvB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,KAAK,UAAU,EAAE;CACjB,OAAO,WAAW,EAAE;AACrB;;AAEA;CACC,KAAK,WAAW;CAChB,OAAO,UAAU,EAAE;AACpB;;AAEA;CACC,wBAAwB;CACxB,sBAAsB;CACtB,8BAA8B;CAC9B,mCAAmC;AACpC;;AAEA;CACC,+BAA+B;CAC/B,wBAAwB;CACxB,8BAA8B;CAC9B,mCAAmC;AACpC;;;AAGA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,YAAY;;CAEZ,yBAAyB;AAC1B;;AAEA;AACA;;;;;;CAMC;CACA,gBAAgB;CAChB,kBAAkB;;CAElB,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;IACP,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,UAAU;AACd;;;AAGA;CACC,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;;CAElB,kBAAkB;CAClB,eAAe;AAChB;;;AAGA;;CAEC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,eAAe,EAAE,SAAS;CAC1B,SAAS;CACT,cAAc;CACd,gBAAgB;;AAEjB;;AAEA;CACC,gBAAgB;CAChB,oCAAoC;CACpC,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,MAAM;CACN,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,gBAAgB,EAAE,SAAS;CAC3B,kBAAkB;AACnB;;AAEA;;CAEC,YAAY;AACb;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,YAAY;;AAEb;;AAEA;CACC,UAAU;CACV,yBAAyB;CACzB,eAAe;CACf,sBAAsB;CACtB,gBAAgB;;AAEjB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA;CACC,cAAc;CACd,SAAS;AACV;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;CAEC,gBAAgB;CAChB,SAAS;CACT,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,qBAAqB;CACrB,mBAAmB;CACnB,WAAW;CACX,WAAW;CACX,iBAAiB;CACjB,oHAAoH;CACpH,4BAA4B;CAC5B,wBAAwB;AACzB;;;AAGA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,SAAS;CACT,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,aAAa;CACb,sBAAsB;CACtB,sBAAsB;CACtB,YAAY;AACb;;;AAGA;CACC;EACC,4BAA4B;EAC5B,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,0BAA0B;EAC1B,UAAU;CACX;AACD;;AAEA;CACC,4BAA4B;CAC5B,UAAU;CACV,6BAA6B;CAC7B,sBAAsB;CACtB,6BAA6B;AAC9B;;AAEA,iDAAiD,mBAAmB,EAAE;AACtE,iDAAiD,mBAAmB,EAAE;AACtE,iDAAiD,mBAAmB,EAAE;;AAEtE;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,4BAA4B;CAC5B,2BAA2B;CAC3B,2BAA2B;CAC3B,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;AACzB","sourcesContent":["@font-face {\n\tfont-family: 'KPMG';\n\tsrc: url( '../fonts/KPMG-Light.ttf' );\n\tfont-style: normal;\n\tfont-weight: 400;\n}\n\n@font-face {\n\tfont-family: 'KPMG';\n\tsrc: url( '../fonts/KPMG-Bold.ttf' );\n\tfont-style: normal;\n\tfont-weight: 700;\n\tfont-weight: bold;\n}\n\n@font-face {\n\tfont-family: 'KPMG';\n\tsrc: url( '../fonts/KPMG-Extralight.ttf' );\n\tfont-style: normal;\n\tfont-weight: 200;\n}\n\n@font-face {\n\tfont-family: 'KPMG';\n\tsrc: url( '../fonts/KPMG-Thin.ttf' );\n\tfont-style: normal;\n\tfont-weight: 100;\n}\n\nbody {\n\tfont-family: 'Open Sans', sans-serif;\n\tfont-size: 12pt;\n\tmargin: 0;\n\tpadding: 0;\n\tcolor: #02277A;\n\n\tbackground: #fff url( 'https://stssehub749064224099.blob.core.windows.net/aicoach-assets/layout/bg-trades.png' ) bottom center no-repeat;\n\tbackground-size: cover;\n\n\t/* Prevent long-click */\n\t-webkit-touch-callout: none !important;\n}\n\nbody.welcome,\nbody.instructions { background-image: url('https://stmatchmaker048851067649.blob.core.windows.net/matchmakerassets/layout/bg-form-instructions.png'); }\nbody.interview { background-image: url('https://stssehub749064224099.blob.core.windows.net/aicoach-assets/layout/bg-conversation-trades.png'); }\n\na {\n\tcolor: #8cdce8;\n}\n\nhtml, body, #page {\n\theight: 100%;\n\tbox-sizing: border-box;\n}\n\n/*\nheader, footer, div {\n\tborder: solid red 1px;\n}\n\nheader:after, footer:after, div:after {\n\tcontent: 'x';\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tbackground-color: #33333333;\n\n}\n*/\n\n#page {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 5vh 7vw;\n\n\t/* Used by speaker viz */\n\tposition: relative;\n\toverflow: hidden;\n}\n\n#content {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n/*\nheader {\n\tposition: absolute;\n\ttop: 5vh;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 5%;\n}\n\nfooter {\n\tz-index: -10;\n\tposition: absolute;\n\tbottom: 5vh;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 5%;\n}\n*/\n\nfooter {\n\n}\n\n.logo {\n\twidth: 10vw;\n\theight: auto;\n}\n\n#synapse-logo {\n\ttext-align: right;\n}\n\n#synapse-logo img {\n\tmax-width: 15vw;\n}\n\n/*\n#kpmg-logo {\n\tposition: absolute;\n\tleft: 0;\n}\n\n#synapse-logo {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n}\n\n*/\n@media screen and ( max-width:767px ) {\n\t#kpmg-logo {\n\t\tright: 0;\n\t\ttext-align: center;\n\t\tmax-width: 100%;\n\t}\n\n\t.logo { width: 50vw; }\n\n\t#synapse-logo {\n\t\tleft: 0;\n\t\ttext-align: center;\n\t}\n\n\t#synapse-logo img {\n\t\tmax-width: 100%;\n\t}\n\n\t#audio_anim_container {\n\t\tmargin-top: 10vh;\n\t}\n\t\n\t#agent_output {\n\t\tpadding-top: 3vh;\n\t\tpadding-bottom: 3vh;\n\t}\n\n\tbody #content {\n\t\twidth: 100%;\n\t\tpadding: 0;\n\t}\n}\n\n#content {\n\twidth: 65%;\n\theight: 80vh;\n\n\tmargin: 0 auto;\n\tpadding: 0 15px;\n\tfont-size: 1.5vw;\n\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\n\n#content.reg-form {\n\tfont-size: 1.2vw;\n}\n\nbody.results #content {\n\tfont-size: 1.1vw;\n\ttop: 10%;\n\tleft: 10%;\n\tright: 10%;\n\theight: auto;\n\tpadding-bottom: 10vh;\n\toverflow: hidden;\n}\n\n.aligncenter {\n\ttext-align: center;\n}\n\nh1 {\n\tfont-family: KPMG, sans-serif;\n\ttext-align: center;\n\tmargin-top: 0;\n\tfont-size: 4.5vw; /*64pt;*/\n}\n\n.button,\nbutton {\n\tmargin: 10px 5px;\n\tpadding: .5em 1em;\n\tfont-size: inherit;\n\tbackground-color: #02277A;\n\tcolor: #fff;\n\tborder: inset #ccc 1px;\n\tborder-radius: 10px;\n}\n\n.button:active,\nbutton:active {\n\tposition: relative;\n\ttop: 2px;\n\tleft: 2px;\n}\n\n#volume_meter {\n\twidth: 100px;\n\theight: 10px;\n\tborder: solid 1px black;\n}\n\n#login-form {\n\tbackground-color: #fff;\n\tcolor: #000;\n\tmax-width: 300px;\n\tmargin: auto;\n\tpadding: 2em;\n\tborder-radius: .5em;\n}\n\n#login-form .message {\n\tborder: solid 1px #ccc;\n\tbackground-color: #eee;\n\tpadding: 5px;\n\tmargin-bottom: 1em;\n}\n\n.reg-form .message {\n\tborder: solid 1px #ccc;\n\tbackground-color: #eee;\n\tpadding: 5px;\n\tmargin-bottom: 1em;\n}\n\n\n.choice-panels,\n#topics {\n\tcolumn-gap: 1em;\n\tmargin-top: 30px;\n}\n\n.choice,\n.topic {\n\tdisplay: block;\n\tborder: solid #02277A 1px;\n\tborder-radius: 15px;\n\tmargin-bottom: 1em;\n}\n\n.choice:hover,\n.topic:hover {\n\tbackground-color: #2f51a0;\n\tcolor: #fff;\n\tcursor: pointer;\n}\n\n.choice h2,\n.topic h2 {\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n\tline-height: 1.3;\n}\n\na.choice {\n\tcolor: #2f51a0;\n\ttext-decoration: none;\n}\n\n#audio_anim_container {\n\tz-index: 10;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n}\n\n#audio_anim {\n\theight: auto;\n\tmax-width: 100%;\n\tmax-height: 30vh;\n\tobject-fit: fill;\n\topacity: 1;\n\tscale: 1;\n\ttransition: scale .1s, opacity .1s;\n\tclip-path: inset(1px 1px); /* Fixed black lines around video when scaling */\n}\n\n#thinking_indicator {\n\tposition: relative;\n\topacity: 0;\n\ttop: -10px;\n\tcolor: #2faff3;\n\ttransition: opacity .1s;\n\tfont-size: .8em;\n\tanimation: none;\n}\n\n#thinking_indicator:after {\n\tcontent: '...';\n\tposition: absolute;\n}\n\n@keyframes thinking {\n\t0% { opacity: 1; }\n\t100% { opacity: .5; }\n}\n\n@keyframes thinking_phrase {\n\t0% { opacity: 0 }\n\t100% { opacity: 1; }\n}\n\n.thinking #audio_anim {\n\tanimation-name: thinking;\n\tanimation-duration: 1s;\n\tanimation-direction: alternate;\n\tanimation-iteration-count: infinite;\n}\n\n.thinking #thinking_indicator {\n\tanimation-name: thinking_phrase;\n\tanimation-duration: 2.5s;\n\tanimation-direction: alternate;\n\tanimation-iteration-count: infinite;\n}\n\n\n#speaker_visualizer {\n\tposition: absolute;\n\ttop: 100%;\n\tleft: 0;\n\tright: 0;\n\tborder-radius: 100%;\n\twidth: 60vw;\n\theight: 20vw;\n\tmargin: auto;\n\n\tbox-shadow: 0 0 0 #355fe7;\n}\n\n#agent_output {\n/*\n\tposition: relative;\n\tz-index: 20;\n\tmargin-top: 0;\n\n\theight: 41vh;\n*/\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\n\tfont-size: 28px;\n\twhite-space: pre-line;\n}\n\n.narrow-width {\n\tmax-width: 800px;\n}\n\n.form-field {\n\tmargin-bottom: 1em;\n}\n\n.form-field label {\n\tdisplay: inline-block;\n\tmin-width: 40%;\n}\n\n.form-field input {\n\tfont-size: inherit;\n}\n\n.form-field input[type=text] {\n\twidth: 50%;\n    border: solid #ccc 2px;\n    padding: .5em;\n    font-size: 18px;\n}\n\n\n.form-field label:after {\n    content: ' *';\n    color: red;\n}\n\n\n.form-submit input[type=submit] {\n\tcolor: #fff;\n\tbackground: #02277A;\n\tborder: none;\n\tborder-radius: 5px;\n\n\tfont-size: inherit;\n\tcursor: pointer;\n}\n\n\n.selector,\n#event_selector {\n\tpadding: .5em 1em;\n\tfont-size: inherit;\n\tbackground: #fff;\n\tborder: solid #02277A 2px;\n\tborder-radius: 15px;\n}\n\n.selector,\n#selector_button {\n\tfont-size: .75em;\n}\n\nbody.intro h1 {\n\tposition: relative;\n\tfont-weight: bold;\n\tfont-size: 11vw; /*175pt;*/\n\tmargin: 0;\n\tmargin-top: 5%;\n\tline-height: 1.1;\n\n}\n\nbody.intro .heading-prefix {\n\tfont-weight: 300;\n\tfont-family: 'Open Sans', sans-serif;\n\tcolor: #8a8a8a;\n\tposition: absolute;\n\tleft: 23%;\n\ttop: 0;\n\tfont-size: 2.5vw;\n\tletter-spacing: -.15vw;\n}\n\nbody.intro .heading-smart {\n\tcolor: #2faff3;\n}\n\nbody.intro .event_name {\n\tfont-weight: 300;\n\tcolor: #4d4d4d;\n\tmargin: 0;\n}\n\nbody.intro #content {\n\tfont-size: 1.9vw;\n\tline-height: 1.1;\n}\n\n.press-to-continue,\nbody.intro .instructions {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tfont-size: 1.4vw; /* 20pt;*/\n\ttext-align: center;\n}\n\nbody.welcome .press-to-continue,\nbody.instructions .press-to-continue {\n\tbottom: 10vh;\n}\n\n.sme-mockup {\n\n\tmax-width: 100%;\n\tmax-height: 33vh;\n\twidth: auto;\n\theight: auto;\n\n}\n\n.expert {\n\twidth: 20%;\n\tborder: solid #02277A 1px;\n\tfont-size: .8em;\n\tbackground-color: #fff;\n\ttext-align: left;\n\n}\n\n.expert .expert-photo {\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n\tbackground-color: #ccc;\n\tborder-bottom: solid black 5px;\n}\n\n.expert-name {\n\tcolor: #02277A;\n\tmargin: 0;\n}\n\n.expert-details {\n\tcolor: #888;\n\tpadding: .5em 1em;\n}\n\nbody.welcome #page,\nbody.instructions #page {\n\tpadding-top: 15vh;\n}\n\nbody.welcome #content h1,\nbody.instructions #content h1 {\n\ttext-align: left;\n\tmargin: 0;\n\tmargin-bottom: .18em;\n}\n\n#instruction-content {\n\tposition: relative;\n\tcolor: #666666;\n\tpadding-left: 70px;\n}\n\n#instruction-content:before {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tcontent: '';\n\twidth: 50px;\n\tmin-height: 100px;\n\tbackground-image: url('https://stmatchmaker048851067649.blob.core.windows.net/matchmakerassets/layout/icon-mic.png');\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n}\n\n\nbody.registration #heading {\n\tposition: absolute;\n\ttext-align: left;\n\ttop: 20vh;\n\tleft: 15%;\n\twidth: 20%;\n}\n\nbody.registration #heading h1 {\n\ttext-align: left;\n\tline-height: 1;\n\tmargin: 0;\n}\n\nbody.registration #content {\n\tposition: absolute;\n\tleft: 35%;\n\ttop: 15vh;\n\tpadding: 30px;\n\tborder: solid 1px #ccc;\n\tbox-sizing: border-box;\n\theight: auto;\n}\n\n\n@keyframes expert-reveal {\n\t0% {\n\t\ttransform: translateY(100vh);\n\t\topacity: 0;\n\t}\n\n\t50% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\ttransform: translateY(0vh);\n\t\topacity: 1;\n\t}\n}\n\nbody.results #sme-results .expert  {\n\ttransform: translateY(100vh);\n\topacity: 0;\n\tanimation-name: expert-reveal;\n\tanimation-duration: 2s;\n\tanimation-fill-mode: forwards;\n}\n\nbody.results #sme-results .expert:nth-child(1) { animation-delay: 1s; }\nbody.results #sme-results .expert:nth-child(2) { animation-delay: 2s; }\nbody.results #sme-results .expert:nth-child(3) { animation-delay: 3s; }\n\nbody.end #content {\n\tmargin-top: 4vw;\n\tfont-size: 1.7vw;\n}\n\n#end-qr-code {\n\tfloat: right;\n\twidth: 15vw;\n}\n\n#talk_trigger {\n\tz-index: 30;\n\tposition: absolute;\n\tinset: 0;\n}\n\n.listening #talk_trigger {\n\tbackground-color: rgba(5, 24, 170, 0.3);\n}\n\n#talk_notice {\n\tborder-radius: 50%;\n\tborder: solid 4px #00348d;\n\theight: calc(min(80vw,80vh));\n\twidth: calc(min(80vw,80vh));\n\tbackground-color: #ffffffbb;\n\tcolor: #00348d;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n\tfont-weight: bold;\n\tfont-size: 1.5em;\n}\n\n#talk_notice:focus-visible {\n\toutline: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
